import React, { useEffect, useState } from "react";
import developerApi from "../api/developerApi";
import "./IntegrationsPage.css";

const TABLETKI_FIELDS = {
    endpoint_catalog: "",
    endpoint_stock: "",
    endpoint_orders: "",
    morion: "",
    tabletki: "",
    barcode: "",
    optima: "",
    badm: "",
    venta: "",
};

const sections = [
    {
        title: "Глобальные endpoints",
        fields: [
            ["endpoint_catalog", "Endpoint каталога"],
            ["endpoint_stock", "Endpoint остатков"],
            ["endpoint_orders", "Endpoint заказов"],
        ],
    },
    {
        title: "Статические коды / служебные данные",
        fields: [
            ["morion", "Код Morion"],
            ["tabletki", "Код Tabletki"],
            ["barcode", "Штрихкод"],
            ["optima", "Код Optima"],
            ["badm", "Код Badm"],
            ["venta", "Код Venta"],
        ],
    },
];

const pickTabletkiFields = (settings) => Object.keys(TABLETKI_FIELDS).reduce((result, key) => ({
    ...result,
    [key]: settings?.[key] || "",
}), {});

const TabletkiIntegrationPage = () => {
    const [draft, setDraft] = useState(TABLETKI_FIELDS);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState("");
    const [error, setError] = useState("");

    const loadSettings = async () => {
        setLoading(true);
        setStatus("");
        setError("");
        try {
            const data = await developerApi.getSetting();
            setDraft(pickTabletkiFields(data));
        } catch (err) {
            console.error("Ошибка загрузки настроек Tabletki:", err);
            setError("Не удалось загрузить настройки Tabletki.ua.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadSettings();
    }, []);

    const saveSettings = async () => {
        setStatus("");
        setError("");
        try {
            const saved = await developerApi.updateSettingFields(draft);
            setDraft(pickTabletkiFields(saved));
            setStatus("Настройки Tabletki.ua сохранены.");
        } catch (err) {
            console.error("Ошибка сохранения настроек Tabletki:", err);
            setError("Не удалось сохранить настройки Tabletki.ua.");
        }
    };

    return (
        <>
            <section className="ip-card">
                <div className="ip-card-body">
                    <div className="ip-save-bar" style={{ borderTop: "none", paddingTop: 0, marginTop: 0 }}>
                        <button type="button" className="ip-btn ip-btn-primary" onClick={saveSettings}>Сохранить</button>
                        <button type="button" className="ip-btn" onClick={loadSettings}>Сбросить</button>
                    </div>
                    {loading && <div className="ip-status">Загрузка настроек...</div>}
                    {status && <div className="ip-status" style={{ color: "var(--ip-good-text)" }}>{status}</div>}
                    {error && (
                        <div className="ip-callout danger">
                            <span className="ip-ic">✕</span>
                            <span>{error}</span>
                        </div>
                    )}
                </div>
            </section>

            {sections.map((section) => (
                <section key={section.title} className="ip-card">
                    <div className="ip-card-body">
                        <h2 className="ip-title">{section.title}</h2>
                        <div className="ip-grid3">
                            {section.fields.map(([key, label]) => (
                                <label key={key} className="ip-fld">
                                    <span>{label}</span>
                                    <input
                                        type="text"
                                        className="ip-inp"
                                        value={draft[key]}
                                        onChange={(event) => setDraft({ ...draft, [key]: event.target.value })}
                                    />
                                </label>
                            ))}
                        </div>
                    </div>
                </section>
            ))}
        </>
    );
};

export default TabletkiIntegrationPage;
